/* eslint-disable @next/next/no-img-element */
import { useEffect, useState } from "react";
import { get, isEmpty, isArray } from "lodash";
import { getCookie } from "../framework/libs/cookie";
import { TOKEN_CONGDONG, TOKEN_SHOP } from "../framework/store/constants";
import http from "../utilities/http";
import dayjs from "dayjs";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { numberWithCommas, countDownTimerTemp } from "utilities/helper";
import Link from 'next/link';
import Image from 'next/image';
import { API_URL } from "utilities/constants";
import Product from 'components/shop/product/index';
import { useCart } from "framework/store";

export default function Index({ coupon, vendor, fetch = null }) {
    const [stateStore, actions] = useCart();
    const isSave = stateStore.savedCoupon.some(x => coupon.id == x.id || coupon.rule_id == x.id);

    const [state, _setState] = useState({
        item: coupon,
        modal: false,
        isSave: isSave
    });
    const setState = (_state = {}) => {
        _setState({
            ...state,
            ..._state
        });
    };

    useEffect(() => {
        setState({ isSave: isSave });
    }, []);
    useEffect(() => {
        setState({ item: coupon });
    }, [coupon]);

    const vendorLogo = vendor?.logo;
    const vendorName = vendor?.company || vendor?.shop_name || vendor?.name || vendor?.vendor_id;

    const fetchSavedCoupon = async () => {
        if(isEmpty(getCookie(TOKEN_SHOP))) return;
        const res = await http('/rest/V1/customer/coupons', { size: 0 }, { token: `Bearer ${getCookie(TOKEN_SHOP)}` });
        if (isArray(res)) {
            actions.setSavedCoupon(res || []);
        }
    };
    const saveCoupon = async (item) => {
        setState({ modal: false });
        if (isEmpty(getCookie(TOKEN_CONGDONG))) {
            toast.info('Bạn cần đăng nhập trước khi lưu mã giảm giá');
            return;
        };
        const saveCoupon = await http('/rest/V1/customer/coupon', {}, {
            token: `Bearer ${getCookie(TOKEN_SHOP)}`,
            method: 'POST',
            body: {
                data: {
                    coupon_id: item?.id || item?.rule_id,
                    type: item?.id ? 'vendor' : 'admin'
                }
            }
        });
        if (get(saveCoupon, 'success')) {
            setState({ isSave: true });
            fetchSavedCoupon();
            if (fetch) fetch();
        } else { 
            toast.error('Mã giảm giá đã được lưu hoặc không có hiệu lực');
        }
    };
    const couponContent = (modal) => {
        return <div className="discountBox" style={modal ? { backgroundColor: 'white' } : {}}>
            <div className="discount-design">
                <div className="discount-thumb wrap-next-image-not-crop">
                    <img src={vendorLogo || 'https://happynest.vn/home2017-assets/avatar-happynest@2x.png'} alt="" />
                </div>
                <p> {vendorName || (state.item?.type === 'admin' ? "Happynest" : "Mã khuyến mãi")}</p>
            </div>
            <div className="discount-content">
                <div className="discount-info">
                    <h3 className="discount-title">{state.item?.name}</h3>
                    {/* <p className="discount-inhaus">{vendorName || "Mã khuyến mãi"}</p> */}
                    <p className="discount-expiryDate">HSD: {dayjs(state?.item?.to_date).format('DD.MM.YYYY')}</p>
                    <p className="discount-dateTime">{countDownTimerTemp(state?.item.to_date, 'nữa sẽ hết hạn')}</p>
                    {/* {state?.item?.code ?
                        <p className="discount-lable">Mã {state?.item?.code}</p>:
                        <p className="discount-lable">Chiết khấu {displayWithK(state?.item?.discount_amount)}</p>
                    } */}
                    {modal ? <></> : <span className="item-infoSquare" onClick={() => setState({ modal: true })}></span>}
                    <div className="discount-btn">
                        {!isSave && <button className="btn btn--blue" onClick={() => { saveCoupon(state?.item); }}>Lưu</button>}
                        {isSave && <button className="btn btn--gray" disabled>Đã lưu</button>}
                    </div>
                </div>
            </div>
        </div>;
    };

    const getCouponDescription = () => {
        let couponDes = state?.item?.description || "";
        if (state?.item.coupon_type == 1) {
            if (state?.item.discount_type === 'by_percent') {
                couponDes = `Giảm giá ${numberWithCommas(+state?.item.amount)}%`
                            + (state?.item.discount_max ? ` (tối đa ${numberWithCommas(state?.item.discount_max)}đ) ` : ``)
                            + (state?.item.subtotal ? ` cho đơn hàng từ ${numberWithCommas(state?.item.subtotal)}đ` : ``)
                            + `.`;
            }

            if (state?.item.discount_type === 'by_fixed') {
                couponDes = `Giảm giá ${numberWithCommas(+state?.item.amount)}đ`
                            + (state?.item.subtotal ? ` cho đơn hàng từ ${numberWithCommas(state?.item.subtotal)}đ` : '')
                            + `.`;
            }
        };

        if (state?.item.coupon_type == 2) {
            if (state?.item.discount_type === 'by_percent') {
                couponDes = `Giảm ${numberWithCommas(+state?.item.amount)}% cước vận chuyển`
                            + (state?.item.discount_max ? ` (tối đa ${numberWithCommas(state?.item.discount_max)}đ)` : ``)
                            + (state?.item.subtotal ? ` cho đơn hàng từ ${numberWithCommas(state?.item.subtotal)}đ` : ``)
                            + `.`;
            }

            if (state?.item.discount_type === 'by_fixed') {
                couponDes = `Giảm ${numberWithCommas(+state?.item.amount)}đ cước vận chuyển`
                            + (state?.item.subtotal ? ` cho đơn hàng từ ${numberWithCommas(state?.item.subtotal)}đ` : `.`)
                ;
            }
        };

        if (state?.item.coupon_type == 3) {
            couponDes = "Miễn phí vận chuyển" + (state?.item.subtotal ? ` cho đơn hàng từ ${numberWithCommas(state?.item.subtotal)}đ` : `.`);
        };

        if (!couponDes) return <></>;

        return <>
            <h3 className="mtitle">Ưu đãi</h3>
            <p className="text" style={{ whiteSpace: 'pre-line' }}>{couponDes}</p>
        </>;
    };
    const [productDisplay, setProductDisplay] = useState([]);
    const fetchProduct = async () => {
        const param = {
            filters: [[
                {
                    field: 'sku',
                    value: state.item?.products.map(x => x.sku).join(','),
                    condition_type: 'in'
                }]],
        };
        const res = await http(`/rest/default/V1/products`, param, { token: 'default' });
        setProductDisplay(res.items || []);
    };

    useEffect(() => {
        if (!state.modal) return;
        if (isEmpty(state.item?.products)) return;
        if (!isEmpty(productDisplay)) return;
        fetchProduct();
    }, [state.modal]);

    const genDieuKienApDung = () => {
        let maxUsedTime = 0;
        let categories = [];
        let products = [];
        maxUsedTime = state.item?.usage_per_customer || (!isEmpty(state.item?.coupons) ? state.item?.coupons[0].usage_per_customer : 0);
        categories = state.item?.categories || []; 
        products = state.item?.products || [];
        return <>
            <h3 className="mtitle">Điều kiện áp dụng</h3>
            {maxUsedTime > 0 && <p className="text mb-2">- Mỗi khách hàng được sử dụng tối đa {maxUsedTime} lần.</p>}
            {!isEmpty(categories) && <p className="text mb-2">- Áp dụng cho các ngành hàng:</p>}
            {!isEmpty(categories) && <div className="mb-2">
                <ul style={{
                    whiteSpace: 'nowrap',
                    overflowX: 'scroll'
                }}>
                    {categories.map((item, index) => (<li key={item.name + index} className="ml-2 mr-2" style={{ display: 'inline-block', fontSize: 12, textAlign: 'center', whiteSpace: 'break-spaces', width: '25%' }}>
                        <div className="serviceList_thumb">
                            <Image src={API_URL + item.image} alt={item.name} width={68} height={70} /></div>
                        {item.name}
                    </li>))}
                </ul>
            </div>}

            {!isEmpty(products) && <p className="text mb-2">- Áp dụng cho các sản phẩm</p>}
            {!isEmpty(productDisplay) && <div className="productsLst mb-2">
                <ul style={{
                    whiteSpace: 'nowrap',
                    overflowX: 'scroll',
                    display: 'block'
                }}>
                    {productDisplay.map((item, index) => (<li key={`${item.sku}` + index} className="ml-2 mr-2 mt-1" style={{ display: 'inline-block', fontSize: 12, width: '30%'}}>
                        {/*<div><Image src={API_URL + item.image} alt={item.name} width={68} height={70} /></div> */}
                        <Product item={item}></Product>
                    </li>))}
                </ul>
            </div>}
        </>;
    };
    return <li className={(state?.item?.code || !isEmpty(state?.item?.codes)) ? "" : "code-promo"}>
        <Modal show={state.modal} onHide={() => { setState({ modal: false }); }} className="modal_conditions-code">
            <Modal.Header closeButton>
                <h5 className="modal-title">Thông tin mã giảm giá</h5>
            </Modal.Header>
            <Modal.Body >
                <div className="discount">
                    <ul><li className={"w-100 " + (state?.item?.code ? "" : "code-promo")}>{couponContent(true)}</li></ul>
                </div>

                <h3 className="mtitle">Mã code</h3>
                <p className="text">{state?.item?.code || (!isEmpty(state?.item?.codes) ? state?.item?.codes[0].code : '')}</p>

                {getCouponDescription()}

                {genDieuKienApDung()}

                <h3 className="mtitle" style={{ marginTop: 20}}>Hạn sử dụng</h3>
                <p className="">{dayjs(state?.item?.to_date).format('DD/MM/YYYY HH:mm:ss')}</p>
            </Modal.Body>
            {/* <Modal.Footer>
                <Button style={{ width: "50%" }} variant="primary" onClick={() => { setState({ modal: false }); }} className="btn">Xong
                </Button>
            </Modal.Footer> */}
        </Modal>
        {couponContent()}
    </li>;
}